module.exports = __webpack_public_path__ + "img/calendario-black.25275232.svg";